export const fmtUsd = (v, d = 2) =>
  v == null || isNaN(v)
    ? "$0.00"
    : `$${Number(v).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d })}`;

export const fmtNum = (v, d = 2) =>
  v == null || isNaN(v)
    ? "0"
    : Number(v).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmtCompact = (v) =>
  v == null || isNaN(v)
    ? "0"
    : Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 2 }).format(v);

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");

export const pct = (v, d = 2) => `${Number(v || 0).toFixed(d)}%`;

export function countdown(target) {
  const diff = Math.max(0, new Date(target).getTime() - Date.now());
  const s = Math.floor(diff / 1000);
  const h = String(Math.floor(s / 3600)).padStart(2, "0");
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  const sec = String(s % 60).padStart(2, "0");
  return { h, m, sec, done: diff === 0 };
}
